export class UserRole {
    userId: number;
    roleId: number;
    roleName: string;
}
